import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransferOrganizationComponent } from './transfer-organization.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: TransferOrganizationComponent,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [TransferOrganizationComponent],
})
export class TransferOrganizationComponentModule {}
